import Swiper from 'swiper';
/* eslint-disable import/no-unresolved */
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/autoplay';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/effect-fade';
/* eslint-disable import/no-unresolved */
import 'swiper/css/pagination';

export class Slider {
  constructor(swiperContainer, parameters = {}) {
    this.container = swiperContainer;
    this.parameters = parameters;
    this.instance = null;
  }

  init() {
    this.active();
  }

  active() {
    // eslint-disable-next-line no-undef
    this.instance = new Swiper(this.container, this.parameters);
  }

  inactive() {
    if (this.instance !== null) {
      this.instance.destroy();
      this.instance = null;
    }
  }
}
